import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import authReducer from './auth/authSlice';
import chatReducer from './chat/chatSlice';
import newsReducer from './news/newsSlice';
import updatesHubReducer from './updates-hub/updatesHubSlice';
import clientBadgesReducer from './client-badges/clientBadgesSlice';

// Конфигурация store
export const store = configureStore({
  reducer: {
    auth: authReducer,
    chat: chatReducer,
    news: newsReducer,
    updatesHub: updatesHubReducer,
    clientBadges: clientBadgesReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: import.meta.env.MODE !== 'production',
});

// Типы для TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Типизированные хуки
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Селекторы для auth
export const selectAuth = (state: RootState) => state.auth;
export const selectUser = (state: RootState) => state.auth.user;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectAuthLoading = (state: RootState) => state.auth.loading;
export const selectAuthError = (state: RootState) => state.auth.error;

// Селекторы для chat
export const selectChat = (state: RootState) => state.chat;
export const selectConversations = (state: RootState) => state.chat.conversations;
export const selectActiveConversationId = (state: RootState) => state.chat.activeConversationId;
export const selectChatMessages = (state: RootState) => state.chat.messages;
export const selectChatLoading = (state: RootState) => state.chat.loadingConversations;

// Селекторы для news
export const selectNewsUnreadCount = (state: RootState) => state.news.unreadCount;

// Селекторы для updatesHub
export const selectBadges = (state: RootState) => state.updatesHub.badges;

// Селектори для clientBadges
export const selectClientBadges = (clientId: number) => (state: RootState) =>
  state.clientBadges.byClientId[clientId];
